import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ModalCore } from "src/Pages/components";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";
import { FormContato } from "./FormContato";
import { FormContrato } from "./FormContrato";
import { FormDados } from "./FormDados";
import { FormTitular } from "./FormTitular";
import { UseFeatFormContratos } from "./Hooks/UseFeaturesFormulario";
import { UploadWithIAContract } from "./UploadContract/UploadWithIAContract";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { IconButton } from "@mui/material";
import { KeyboardArrowDownIcon } from "src/Pages/components/Icons/Icons";
import { KeyboardArrowRight } from "@mui/icons-material";

interface IModalContrato {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalContratos = ({ openModal, setOpenModal }: IModalContrato) => {
  const { userPerfil } = useAuthContext();
  const { resetInputs } = useResetInputs();

  const [openContato, setOpenContato] = useState(false);

  const { handleSubmit, loading: loadingSubmit } = UseFeatFormContratos({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <>
      <ButtonCore
        disabled={
          userPerfil?.type_user === "USER" &&
          !userPerfil?.permissions.permissions.includes(
            valuesPermissions.CONTRATO.CREATE.id
          )
        }
        startIcon={<AddIcon />}
        title="Criar Contrato"
        onClick={() => setOpenModal(true)}
      />

      <ModalCore
        loadingSubmit={loadingSubmit}
        open={openModal}
        setOpen={setOpenModal}
        sxStyle={{ width: "1350px" }}
        title="Contrato"
        titleSubmit="Salvar"
        onChange={handleSubmit}
      >
        {userPerfil?.empresa.isPlanIA && <UploadWithIAContract />}
        <FormContrato />
        <FormTitular />


        <DividerCore
          title="Contato / Endereço"
          onClick={() => setOpenContato(!openContato)}
          sxStyle={{ cursor: "pointer" }}
          button={
            <IconButton
              sx={{ p: 0 }}
              onClick={() => setOpenContato(!openContato)}
            >
              {openContato ? (
                <KeyboardArrowDownIcon fontSize="small" />
              ) : (
                <KeyboardArrowRight fontSize="small" />
              )}
            </IconButton>
          }
        />
        {openContato && <FormContato />}
        <FormDados />
      </ModalCore>
    </>
  );
};
